/**
 * PMO #23418 — ¿el resultado de una generación de texto vino de un proveedor REAL?
 *
 * Cuando el proveedor de IA falla, el servidor llegó a devolver 200 con un texto de RELLENO
 * (`metadata.provider === 'mock'`: cuatro párrafos que inventan amenidades) y esa descripción
 * se guardó en anuncios de clientes reales. El criterio es FAIL-CLOSED: solo se aplica un
 * texto que traiga `metadata.provider` con un nombre de proveedor; sin metadata, con el
 * proveedor vacío o con `mock`, NO es aplicable.
 *
 * Vive en su propio módulo (y no en ai-text-generation-api.ts) para que los componentes lo
 * importen sin arrastrar el cliente de la API, que muchas pruebas reemplazan entero.
 */
export const esProveedorReal = (metadata: unknown): boolean => {
  const proveedor = (metadata as { provider?: unknown } | null | undefined)?.provider;
  if (typeof proveedor !== 'string') return false;
  const nombre = proveedor.trim().toLowerCase();
  return nombre !== '' && nombre !== 'mock';
};
